import { HttpRequest, HttpHandlerFn, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AutenticacaoService } from '../services';
import { inject } from '@angular/core';
import { catchError, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';

export const tokenInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>, next: HttpHandlerFn
): Observable<HttpEvent<any>> => {

  const auth = inject(AutenticacaoService)

  const router = inject(Router)

  // Não intercepta o refresh token e nem token
  if (req.url.includes('/protocol/openid-connect/token') ) {
    return next(req);
  }

  const token = auth.isLogado() ? auth.obterAccessToken?.() : null

  const clonedReq = token?.trim()
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(clonedReq).pipe(
    catchError(err => {
      if (err.status === 401) {
        return auth.refreshToken().pipe(
          switchMap((refreshOk: boolean) => {
            if (refreshOk) {
              // 3. Obtém novo token e repete request original atualizado
              const novoToken = auth.obterAccessToken();
              const retryReq = novoToken?.trim()
                ? req.clone({ setHeaders: { Authorization: `Bearer ${novoToken}` } })
                : req;
              return next(retryReq);
            } else {

              router.navigate(['/login'])

              return throwError(() => err);
            }
          }),
          catchError(refreshError => {
            // Alguma exception não esperada ocorreu no refresh
            auth.logout({redirect: false});
            router.navigate(['/login'])
            return throwError(() => refreshError);
          })
        );
      } else {
        // Para outros erros, só propaga
        return throwError(() => err);
      }
    })
  );
};
